import React from "react";
import PropTypes from "prop-types";
import { Link, useLocation } from "react-router-dom";
import styles from "./PageSidebar.module.scss";

const PageSidebar = ({
  title,
  icon,
  menuItems = [],
  children,
  className = "",
  defaultActiveId = null,
  isClosable = false,
  onClose = null,
}) => {
  const location = useLocation();
  const currentPath = location.pathname.split("/")[2] || "";

  return (
    <>
      <div className={`${styles.sidebarHeader} ${className}`}>
        <h2 className={styles.sidebarTitle}>
          {icon && <i className={`${icon} ${styles.sidebarIcon}`}></i>}
          {title}
        </h2>
        {isClosable && onClose && (
          <button 
            className={styles.closeButton}
            onClick={onClose}
            aria-label="Close menu"
          >
            <i className="tg-icons-Close"></i>
          </button>
        )}
      </div>
      <div className={styles.sidebarContent}>
        {menuItems.length > 0 && (
          <nav className={styles.sidebarNav}>
            {menuItems.map((item) => {
              const isActive = currentPath === item.id;

              // If item has custom onClick, render as button instead of Link
              if (item.onClick) {
                return (
                  <button
                    key={item.id}
                    onClick={item.onClick}
                    className={`${styles.sidebarLink} ${isActive ? styles.active : ""}`}
                  >
                    {item.title}
                  </button>
                );
              }

              // Default behavior - render as Link
              return (
                <Link
                  key={item.id}
                  to={item.path}
                  className={`${styles.sidebarLink} ${isActive ? styles.active : ""}`}
                >
                  {item.title}
                </Link>
              );
            })}
          </nav>
        )}
        {children}
      </div>
    </>
  );
};

PageSidebar.propTypes = {
  title: PropTypes.string.isRequired,
  icon: PropTypes.string,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      path: PropTypes.string,
      onClick: PropTypes.func, // Optional custom click handler
    }),
  ),
  children: PropTypes.node,
  className: PropTypes.string,
  defaultActiveId: PropTypes.string,
  isClosable: PropTypes.bool,
  onClose: PropTypes.func,
};

export default PageSidebar;
